// import { store } from "@/vuex/store.js"ž
import auth from "@/services/auth";

var timeout = setTimeout(function () { }, 0);
const timeout_minutes = 1200;

var refreshLogoutTimer =  function(){
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      setTimeout(() => {
      location.reload(true);
      }, 2000);
        auth.logout();
      }, timeout_minutes*1000);
}

export {
   refreshLogoutTimer
}